<script setup>
import { useNotificationsStore } from '@/store/notificationsStore';
import { storeToRefs } from 'pinia';
import BaseNotificationCard from './BaseNotificationCard.vue';

const notificationsStore = useNotificationsStore();
const { notifications } = storeToRefs(notificationsStore);
</script>

<template>
  <div class="toast-container">
    <TransitionGroup name="toast">
      <BaseNotificationCard
        v-for="notification in notifications.filter(n => n.isActive)"
        :key="notification.id"
        :notification="notification"
      />
    </TransitionGroup>
  </div>
</template>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 2000;
  display: flex;
  flex-direction: column-reverse;
  gap: 10px;
}
</style>
